<section id="ceo" class="page-banner parallax-section">
    <div class="container-fluid text-center">
        <div class="row">
            <!-- <div class=" wow fadeInLeft col-md-1">
                <div class="d-flex" style="height: 100px;">
                    <div class="vr"></div>
                  </div>
            </div> -->
            <div class="wow fadeInUp offset-md-3 col-md-6 col-sm-7 " data-wow-delay="0.6s">
                <h1>Our CEO</h1>
                <ul>
                    <li>
                        <a routerlink="/" href="/">Home</a>
                    </li>
                    <li>Our CEO</li>
                </ul>
            </div>
        </div>
    </div>
</section>

<section id="ceo-bg" class="ceo-bg">
    <div class="container">
        <div class="row">
            <div class="col-md-6">
                <img class="img img-fluid" src="/assets/images/jpl.png" alt="" onContextMenu="return false;">
            </div>
            <div class="text-center col-md-6">
                <h2 class="content-title">JOEL P. LONGARES</h2>
                <div class="content-bg container text-center">
                    <!-- <p class="text-header"><strong>The Executive Behind 7107 Islands Success:</strong></p> -->
                    <p><strong style="color: #1caa00">The Executive Behind 7107 Islands Success:</strong><br>
                        The man behind 7107 Islands success is its CEO and President Joel P. Longares. A self-made man who rose from rags to riches through hard work and his sheer determination to succeed, his business policy is anchored on the moral value of honesty. A degree holder in marketing and business management, Joel engineered the amazing global growth of Atlas Express Padala, his US core company in the US with branches and partners in the Philippines, Canada, UK, Australia and the Middle East among many others. And with his sharp business acumen, Joel managed to expand his investment to other business interests which he leads under the Longares Group of Companies, a conglomeration of 7 Longares owned and controlled companies. A former OFW himself who worked as a skilled technician in a Saudi Arabia printing company, Joel led 7107 Islands’ shift to specialize on the deployment of skilled and professional workers, knowing fully well that Filipino workers are equally efficient workers, if not even better, than workers from other nations.</p>
                </div>
            </div>
        </div>
        <div class="container wow fadeInDown">
            <blockquote class="text-center">
                <p>Finding Success in 7107 Islands <br>
                    So whether your company is looking for a business partner for help with its manpower needs, or you are a qualified worker looking for the right overseas job, just click on your choice link, and you’re all set to go.</p>
            </blockquote>
        </div>
    </div>
</section>